module.exports = __webpack_public_path__ + "static/img/insta.755e46f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/insta.png
// module id = jA2E
// module chunks = 0